import axios, { AxiosResponse } from 'axios';

interface IRozcestnik {
    zadao?: string;
    emitentje?: string;
    podobacp?: string;
    evidencecp?: string;
    idmb: string;
    stat: string;
}

export interface IRozcestnikData {
    token: string;
    nasledujeweb: string;
    spolecnost: {
        idmb?: string;
        stat?: string;
        lei?: string;
        nazev?: string;
        pravniforma?: string;
        forma?: string; // moze vratit leicheck
        kodpravniformy?: string;
        adma?: string;
        mema?: string;
        pscm?: string;
        kost?: string;
        cval?: string;
    };
}

const isinRozcestnikApi = (data: IRozcestnik) => {
    return axios({
        method: 'POST',
        url: '/ISIN/Rozcestnik',
        data: data
    }).then((resp: AxiosResponse<IRozcestnikData>) => resp.data);
};

export default isinRozcestnikApi;
